import { Wrapper, theme } from "./style";
import React from "react";
import Calendar from '../Components/Calendar'
import Events, { EventProps } from './Event'
import CreatEvent from './Create'
import { ThemeProvider } from '@mui/material/styles';
import { useHorsesStore } from "../../../stores/horses";
import { observer } from "mobx-react";

import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { event } from '../Records/utils'
import dayjs, { Dayjs } from "dayjs";
import { useLocation } from 'react-router-dom';
import { toJS } from "mobx";
import CascadeSelection from "./AddressSelect";
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    clearButton: {
        backgroundColor: 'transparent !important',  // 设置颜色

    }
});

type EventsType = EventProps['events'];
interface FilterProps {
    onChange: (value: string) => void,
    type?: Object
}

export const PublicEvent = {
    'Clinics': 'Clinics',
    'CTR': 'CTR',
    'Dressage': 'Dressage',
    'Endurance': 'Endurance',
    'Eventing': 'Eventing',
    'Hunting': 'Hunting',
    'Miniature Horses': 'Miniature Horses',
    'Misc': 'Misc',
    'Pony Club': 'Pony Club',
    'Show Hunter': 'Show Hunter',
    'Show Jumping': 'Show Jumping',
    'Showing': 'Showing',
    'Training Days': 'Training Days',
    'Racing': 'Racing',
}
const FilterBtn: React.FC<FilterProps> = (props) => {
    const [age, setAge] = React.useState('');

    const handleChange = (event: SelectChangeEvent) => {
        props.onChange(event.target.value);
        setAge(event.target.value);
    };
    return <FormControl sx={{ minWidth: 120, width: '100%' }}>
        <InputLabel id="demo-simple-select-standard-label">Filter By Event Type</InputLabel>
        <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={age}
            onChange={handleChange}
            label="Event Type"
        >
            <MenuItem value={'All Event Type'}>All Event Type</MenuItem>
            {Object.values(props.type ? props.type : event).map(str => {
                return <MenuItem value={str}>{`${str}`}</MenuItem>
            })}

        </Select>
    </FormControl>
}
const Create: React.FC = () => {
    const stores = useHorsesStore()
    const location = useLocation();
    const parmsFromLink = React.useMemo(() => {
        return location.state as { profileId: string }
    }, [location.state])
    return <>
        {stores.getUserRole() &&
            <CreatEvent profileId={parmsFromLink?.profileId} />}
    </>
}

const App: React.FC<{ isPublic: boolean }> = (props) => {
    const stores = useHorsesStore()
    const location = useLocation();
    const [day, setDay] = React.useState<Dayjs>(dayjs);
    const [events, setEvents] = React.useState<EventsType>([]);
    const onEventChange = React.useCallback(async (events: EventsType, day: Dayjs) => {
        const newEvents: EventsType = []
        const promises = events.map(async (item) => {
            console.log(item)
            if (item.profileId) {
                const event = await stores.getCalendarDetail(item.profileId)
                if (event) {
                    newEvents.push(event)
                } else {
                    newEvents.push(item)
                }
            } else {
                newEvents.push(item)
            }
        })

        await Promise.all(promises)

        setEvents(newEvents)
        setDay(day)
    }, [])

    const parmsFromLink = React.useMemo(() => {
        return location.state as { profileId: string }
    }, [location.state])

    React.useEffect(() => {
        if (props.isPublic == true) {
            stores.getAllEvent(undefined, props.isPublic)
        } else {
            const params = location.state as { profileId: string };
            if (params && params.profileId) {
                stores.getCalendar(params.profileId)
            } else {
                stores.getCalendar()
            }

        }

    }, [])

    const deleteHandle = React.useCallback(async (id: string) => {
        const params = location.state as { profileId?: string };
        setEvents(events.filter(item => item._ID != id))
        await stores.deleteCalendar(id, params?.profileId)


    }, [])

    const [region, setRegion] = React.useState("");
    const [city, setCity] = React.useState("");

    const classes = useStyles();
    return <ThemeProvider theme={theme}>
        <Wrapper sx={{
            marginBottom: '20px',
            alignItems: 'flex-start',
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        }}>
            <Stack spacing={2} sx={{
                [theme.breakpoints.down('sm')]: {
                    width: '100%',
                },
            }}>
                <Calendar onChange={onEventChange} events={stores.calendar} loading={stores.calendarLoading} />
                <>{
                    window.reactPress?.user.data.ID ? props.isPublic == true ? <CreatEvent profileId={parmsFromLink?.profileId} isPublic={props.isPublic} /> : <Create /> : null
                }
                </>



            </Stack>

            <Stack spacing={2} ml={2} flexBasis={'30%'} sx={{
                [theme.breakpoints.down('sm')]: {
                    margin: 0,
                    width: '100%',
                },
            }}>
                <Box sx={{
                    boxShadow: '0 1px 4px rgba(0, 0, 0, .0705882353)',
                    borderRadius: '5px',
                    background: '#fff',
                    padding: '16px',
                }}>
                    <Box display="flex" alignItems="center" sx={{ marginBottom: '10px' }}>
                        <FilterBtn

                            onChange={(str) => {
                                if (str === 'All Event Type') {
                                    stores.removeEventTypeFilter()
                                } else {
                                    stores.setEventTypeFilter(str, props.isPublic);
                                    setEvents(events.filter(item => item.title == str));
                                }

                            }}
                            type={props.isPublic == true ? PublicEvent : undefined}
                        />
                        <IconButton onClick={() => stores.removeEventTypeFilter()} className={classes.clearButton}>
                            <ClearIcon />
                        </IconButton>
                    </Box>

                    {props.isPublic == true &&
                        <Box display="flex" alignItems="center">
                            <CascadeSelection
                                region={region} setRegion={setRegion} city={city} setCity={setCity} onChange={(region, city) => {
                                    stores.setRegionFilter({ city: city, region: region });
                                }}
                            />
                            <IconButton onClick={() => stores.removeRegionFilter()} className={classes.clearButton}>
                                <ClearIcon />
                            </IconButton>
                        </Box>

                    }
                </Box>

                <Events events={events} day={day} deleteHandle={deleteHandle} />
            </Stack>

        </Wrapper >
    </ThemeProvider>

}

export default observer(App)
